export const getSortedUserCountries = (
  userCountries: { label: string; value: string }[],
  sortDirection: 'asc' | 'desc',
) => {
  return [...userCountries].sort((a, b) => {
    const compareResult = a?.label?.localeCompare(b.label);
    return sortDirection === 'asc' ? compareResult : -compareResult;
  });
};
